import {
  BerthVisitSearch,
} from "@portbase/bezoekschip-service-typescriptmodels";
import lodash from "lodash";
import {AppContext} from "../../../app-context";
import {NewHarbourDuesVisitSummary} from "./harbour-dues-overview-item.component";

export class HarbourDuesOverviewUtils {
  static toExtendedSummary = (summary: NewHarbourDuesVisitSummary): NewHarbourDuesVisitSummary => {
    const v: NewHarbourDuesVisitSummary = summary;
    v.currentBerthVisit = this.getUpcomingBerthVisit(summary);
    v.lastEditedByUser = summary.lastEditedBy ? summary.lastEditedBy[AppContext.userProfile.organisation?.shortName] : null;
    if (v.lastEditedByUser && !AppContext.isProduction() && !AppContext.isAdmin()) { // Override the username on test environments because multiple customers use the same organisation account
      v.lastEditedByUser.name = v.lastEditedByUser.orgName;
    }

    return v;
  }

  private static getUpcomingBerthVisit = (summary: NewHarbourDuesVisitSummary): BerthVisitSearch =>
    lodash.findLast(summary.berthVisitSearches, bv => !!bv.ata) || summary.berthVisitSearches[0];
}
